import React, { useState, useEffect } from "react";
import "../styles/Forms.css";
import "../styles/Buttons.css";
import {
  convertToInputDateFormat,
  formatDateForDisplay,
} from "../utils/dateUtils";
import CopyToClipboardButton from "../components/CopyToClipboardButton"; 

const AddBatchForm = ({ products, onSubmit }) => {
  const [batchData, setBatchData] = useState({
    batch_no: "",
    product_code: "",
    manufacture_date: "",
    expiry_date: "",
    batch_qr_code: "",
  });

  //  Production Date
  const handleManufactureDateChange = (event) => {
    const newDate = event.target.value;
    setBatchData((prev) => ({ ...prev, manufacture_date: newDate }));
  };

  //  Product
  const handleProductChange = (event) => {
    const newProductCode = event.target.value;
    setBatchData((prev) => ({ ...prev, product_code: newProductCode }));
  };

  //  Batch No
  const handleBatchNoChange = (event) => {
    const newBatchNo = event.target.value;
    setBatchData((prev) => ({ ...prev, batch_no: newBatchNo }));
  };

  // batch_no / product_code
  useEffect(() => {
    if (!batchData.batch_no || !batchData.product_code) {
      setBatchData((prev) => ({ ...prev, batch_qr_code: "" }));
      return;
    }
    const selectedProduct = products.find(
      (p) => p.product_code === batchData.product_code
    );
    if (!selectedProduct) {
      setBatchData((prev) => ({ ...prev, batch_qr_code: "" }));
      return;
    }
    const shortCode =
      selectedProduct.product_short_code || selectedProduct.product_code;
    const qr = `${shortCode}-${batchData.batch_no}`;
    setBatchData((prev) => ({ ...prev, batch_qr_code: qr }));
  }, [batchData.batch_no, batchData.product_code, products]);

  //  manufacture_date / product_code， Expiry Date 
  useEffect(() => {
    if (!batchData.manufacture_date || !batchData.product_code) {
      setBatchData((prev) => ({ ...prev, expiry_date: "" }));
      return;
    }
    const selectedProduct = products.find(
      (p) => p.product_code === batchData.product_code
    );
    if (!selectedProduct) {
      setBatchData((prev) => ({ ...prev, expiry_date: "" }));
      return;
    }
    // Shelf life 
    const shelfLifeMonths = selectedProduct.shelf_life || 0;
    const manufDateObj = new Date(batchData.manufacture_date);
    if (isNaN(manufDateObj.getTime())) {
      setBatchData((prev) => ({ ...prev, expiry_date: "" }));
      return;
    }

    manufDateObj.setMonth(manufDateObj.getMonth() + shelfLifeMonths);
    const display = formatDateForDisplay(manufDateObj.toISOString());
    setBatchData((prev) => ({ ...prev, expiry_date: display }));
  }, [batchData.manufacture_date, batchData.product_code, products]);

  //  Batch URL
  const batchUrl = batchData.batch_qr_code
    ? `https://traceability.nzpuredairy.co.nz/batch?code=${batchData.batch_qr_code}`
    : "";

  // Submit form
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(e, {
      batch_no: batchData.batch_no,
      product_code: batchData.product_code,
      manufacture_date: batchData.manufacture_date,
    });
  };

  return (
    <form className="admin-form" onSubmit={handleSubmit}>
      <label>Batch Number:</label>
      <input
        type="text"
        placeholder="e.g. BN1234"
        value={batchData.batch_no}
        onChange={handleBatchNoChange}
        required
      />
      <p className="info-text">
        A unique batch identifier (once created, it can't be changed).
      </p>

      <label>Product Code:</label>
      <select
        value={batchData.product_code}
        onChange={handleProductChange}
        required
      >
        <option value="">-- Select Product --</option>
        {products
          .filter((p) => p.is_traceable === 1 || p.is_traceable === true)
          .map((product) => (
            <option key={product.product_code} value={product.product_code}>
              {product.product_code} - {product.product_name}
            </option>
          ))}
      </select>

      <label>Manufacture Date:</label>
      <input
        type="date"
        value={batchData.manufacture_date}
        onChange={handleManufactureDateChange}
        required
      />

      <label>Expiry Date (Preview):</label>
      <input type="text" value={batchData.expiry_date} disabled />

      <label>Batch QR Code (Preview):</label>
      <input type="text" value={batchData.batch_qr_code} disabled />
      <p className="info-text">
        *Batch number, product code, and manufacture date are required. Expiry
        date & QR code are calculated automatically (preview only).
      </p>

      {/* Copy link */}
      <CopyToClipboardButton text={batchUrl} label="Copy Batch URL" />

      <button type="submit">Save Changes</button>
    </form>
  );
};

export default AddBatchForm;
